export const equipments = [
    {
        "Title": "4-line phone",
        "ImgUrl": "images/4LineIPPhone.png",
        "PrdID": "25441894",
        "PrdSubCat": "desktop",
        "FeatureList": [
            {
                "name": "Ideal for common areas"
            },
            {
                "name": "HD Voice and headset support."
            }, {
                "name": "132x64px LCD display"
            },
            {
                "name": "Ethernet Connectivity"
            }, {
                "name": "1 year limited warranty"
            }, {
                "name": "3 line keys with LED"
            }/*,{
            "name": "2 x RJ45 10/100/1000 Ethernet ports"
        }*/, {
                "name": '2.3" 132x64-pixel graphical LCD display with backlight'
            }, {
                "name": "Ethernet connection"
            }, {
                "name": "EHS headset support"
            }]
    },
    {
        "Title": "Conference",
        "ImgUrl": "images/conf_phone.png",
        "PrdID": "25518297",
        "PrdSubCat": "desktop",
        "FeatureList": [{
            "name": "Full-duplex speakerphone with AEC Connectivity."
        }, {
            "name": "248x120px LCD display"
        }, {
            "name": "Built-in Wi-Fi"
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Optimal HD audio, full duplex technology"
        }, {
            "name": "Yealink Noise Proof Technology"
        }, {
            "name": "20-foot (6-meter) and 360-degree voice pickup"
        }, {
            "name": "Built - in 3 microphone array"
        }]
    },
    {
        "Title": "12-line phone",
        "ImgUrl": "images/12lineIPPhoneNew.png",
        "PrdID": "25616711",
        "PrdSubCat": "desktop",
        "FeatureList": [{
            "name": "Bluetooth and Wi-Fi built in"
        }, {
            "name": "HD Voice and headset support. Wi-Fi capable."
        }, {
            "name": "360x160px LCD display"
        }, {
            "name": "Ethernet Connectivity"
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "6 line keys can be programmed to support up to 12 lines"
        }/*, {
            "name": "2 x port Gigabit Ethernet connection"
        }*/, {
            "name": "360x160-pixel graphical LCD display with backlight"
        }, {
            "name": "Ethernet connection and Wi-Fi capable"
        }, {
            "name": "EHS Headset support"
        }, {
            "name": "1 x USB port (2.0 compliant)"
        }]
    },
    {
        "Title": "16-line phone",
        "ImgUrl": "images/16lineIPPhone.png",
        "PrdID": "25616710",
        "PrdSubCat": "desktop",
        "FeatureList": [{
            "name": "HD Voice and headset support. Wi-Fi capable."
        }, {
            "name": "480x272px LCD display"
        }, {
            "name": "Ethernet Connectivity"
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "16 line keys"
        }/*, {
            "name": "2 x RJ45 10/100/1000 Ethernet ports"
        }, {
            "name": '2.3" 132x64-pixel graphical LCD with backlight'
        }*/, {
            "name": "480 x 272-pixel color LCD display with backlight"
        }, {
            "name": "2 x port Gigabit Ethernet connection and Wi-Fi capable"
        }, {
            "name": "EHS headset support"
        }, {
            "name": "1 x USB port (2.0 compliant)"
        }]
    },
    {
        "Title": "10-line cordless phone",
        "ImgUrl": "images/img_w56P.png",
        "PrdID": "25645784",
        "PrdSubCat": "codless",
        "FeatureList": [{
            "name": "Color display and intuitive user interface"
        }, {
            "name": "Supports up to 8 handsets."
        }, {
            "name": "HD Voice with wideband technology."
        }, {
            "name": "Quick re-charge time."
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "8-line phone base with 1 handset"
        }, {
            "name": "Color display and intuitive user interface"
        }, {
            "name": "Industry leading handset battery life / quick re-charge time"
        }, {
            "name": "3.5 mm headset jack"
        }]
    },
    {
        "Title": "Additional Cordless handset",
        "ImgUrl": "images/img_w56h.jpg",
        "PrdID": "25419696",
        "PrdSubCat": "codless",
        "FeatureList": [{
            "name": "Requires IP phone base."
        }, {
            "name": "HD Voice with wideband technology."
        }, {
            "name": "Quick re-charge time."
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Upto 8 total handsets can be paired to 1 phone base"
        }, {
            "name": "Color display and intuitive user interface"
        }, {
            "name": "Industry leading handset battery life/quick re-charge time"
        }, {
            "name": "3.5 mm headset jack"
        }]
    },
    {
        "Title": "2-Port Analog Converter",
        "ImgUrl": "images/analogcoverter.png",
        "PrdID": "25237927",
        "PrdSubCat": "accessories",
        "FeatureList": [{
            "name": "Converts analog phone equipment to VoIP."
        }, {
            "name": "2 voice ports"
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Converts existing phone equipment from analog to VoIP Systems"
        }, {
            "name": "2 voice ports"
        }]
    },
    {
        "Title": "4-Port Analog Converter",
        "ImgUrl": "images/analogcoverter.png",
        "PrdID": "25518299",
        "PrdSubCat": "accessories",
        "FeatureList": [{
            "name": "Converts analog phone equipment to VoIP"
        }, {
            "name": "4 voice ports"
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Converts existing phone equipment from analog to VoIP Systems"
        }, {
            "name": "4 voice ports"
        }]
    },
    {
        "Title": "Wifi adapter",
        "ImgUrl": "images/WifiDongle.png",
        "PrdID": "25441897",
        "PrdSubCat": "accessories",
        "FeatureList": [{
            "name": "Requires W-Fi capable phone with USB port."
        }, {
            "name": "Compatible with 12-line and 16-line phones."
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Requires W-Fi capable phone with USB 2.0"
        }, {
            "name": "Compatible with 12 and 16 line IP phones only"
        }, {
            "name": "Network Standard - IEEE802.11b/g/n"
        }, {
            "name": "Transmission Rate - 150 Mbps"
        }]
    },
    {
        "Title": "Bluetooth Adapter",
        "ImgUrl": "images/BTAdapter.png",
        "PrdID": "25441898",
        "PrdSubCat": "accessories",
        "FeatureList": [{
            "name": "Requires IP phone with USB port."
        }, {
            "name": "Connect to 4 Bluetooth devices at once."
        }, {
            "name": "1 year limited warranty"
        }, {
            "name": "Requires IP phones with USB 2.0"
        }, {
            "name": "Bluetooth - V4.0+HS system, A2DP technology"
        }, {
            "name": "Operating Distance - 10 meters"
        }, {
            "name": "Multipoint Technology - Connect with 4 Bluetooth devices at once"
        }]
    }
];

